module.exports = __webpack_public_path__ + "static/media/labfuturo.bd481788.png";